import * as React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import {useState} from "react";
import {useStateContext} from "../../hooks/useStateContext";

export type DuePayload = {
  id: number;
  user_id: number;
  title: string;
  note?: string;
  due_at?: string;
  channel?: string;
};

export function TodoDueDialog({
                                open,
                                todo,
                                onSnooze,
                                onClose,
                                onConfirm
                              }: {
  open: boolean;
  todo?: DuePayload;
  onClose: () => void;
  onSnooze: (item: DuePayload | undefined) => void;
  onConfirm: () => void;
}) {

  const {user} = useStateContext();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{user?.name} - To Do</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6">{todo?.title}</Typography>
        {todo?.note && <Typography sx={{ mt: 1 }}>{todo.note}</Typography>}
        {todo?.due_at && (
          <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
            Deadline: {new Date(todo.due_at).toLocaleString()}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{
          onSnooze(todo);
        }} color={'error'} variant="outlined">Snooze</Button>
        <Button onClick={onConfirm} variant="contained">Done</Button>
      </DialogActions>
    </Dialog>
  );
}
